import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutDashboard, FolderKanban, Wrench, Mail, Settings, LogOut, Home } from "lucide-react";

const LINKS = [
  { to: "/admin/dashboard", icon: LayoutDashboard, label: "Panel" },
  { to: "/admin/projects", icon: FolderKanban, label: "Projeler" },
  { to: "/admin/services", icon: Wrench, label: "Hizmetler" },
  { to: "/admin/messages", icon: Mail, label: "Mesajlar" },
  { to: "/admin/settings", icon: Settings, label: "Ayarlar" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-[#050812] text-white flex" data-testid="admin-layout">
      <aside className="w-64 bg-[#0A0E1A] border-r border-[#1F2937] flex flex-col shrink-0 sticky top-0 h-screen">
        <div className="px-6 py-8 border-b border-[#1F2937]">
          <div className="flex items-center gap-3">
            <div className="w-11 h-11 border border-[#C9A961] flex items-center justify-center text-[#C9A961] font-heading tracking-[0.15em]">YK</div>
            <div>
              <div className="font-heading text-white text-sm tracking-[0.2em]">İNŞAAT</div>
              <div className="text-[#C9A961] text-[9px] tracking-[0.3em] uppercase">Yönetim</div>
            </div>
          </div>
        </div>

        <nav className="flex-1 py-6 px-3 space-y-1">
          {LINKS.map((link) => (
            <NavLink
              key={link.to}
              to={link.to}
              data-testid={`admin-nav-${link.to.split("/").pop()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 text-sm uppercase tracking-[0.15em] transition-colors ${
                  isActive
                    ? "bg-[#C9A961]/10 text-[#C9A961] border-l-2 border-[#C9A961]"
                    : "text-white/60 hover:text-white hover:bg-white/5 border-l-2 border-transparent"
                }`
              }
            >
              <link.icon className="w-4 h-4" strokeWidth={1.5} />
              <span>{link.label}</span>
            </NavLink>
          ))}
        </nav>

        <div className="p-4 border-t border-[#1F2937] space-y-2">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 py-2.5 text-xs uppercase tracking-[0.15em] text-white/60 hover:text-[#C9A961]">
            <Home className="w-4 h-4" /> Siteyi Gör
          </a>
          <button onClick={handleLogout} data-testid="admin-logout" className="w-full flex items-center gap-3 px-4 py-2.5 text-xs uppercase tracking-[0.15em] text-white/60 hover:text-red-400">
            <LogOut className="w-4 h-4" /> Çıkış ({user?.username})
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0 overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
